import { Box, CardMedia as MuiCardMedia } from "@mui/material";
import { PropsWithChildren } from "react";

// `img` does not support pseudo elements so we have to use a box with a background color and a mask
const BlurOverlay = ({ children }: PropsWithChildren) => (
  <Box sx={{ position: "relative" }}>
    {children}
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        mask: "linear-gradient(to bottom, transparent 0%, transparent 50%, black 75%)",
        backdropFilter: "blur(2px)",
        borderRadius: 2.5,
      }}
    />
  </Box>
);

export const CardMedia = ((props: any) => (
  <BlurOverlay>
    <MuiCardMedia {...props} />
  </BlurOverlay>
)) as typeof MuiCardMedia;
